module.exports = __webpack_public_path__ + "img/foot-right-back.0a475aaf.png";